import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { eastonConfig } from "./data";

export default function EastonPage() {
  return <CityPageTemplate config={eastonConfig} />;
}